import React from 'react';

import { StepCard } from './step_card';
import { cleared, latestRecommendations, recommendationQueue } from '../../hooks/use_next_actions';
import { useConversationContext } from '../../conversation_context';

import type { InlineToolCall, ProgressStep } from '../types';

interface Props {
  toolCalls: Extract<InlineToolCall, { name: 'recommendations' }>[];
}

// The queue the run produced is pinned by the surface, so all the transcript keeps of it is the work
// it took to get there.
export function RecommendationSteps({ toolCalls }: Props) {
  const { messages } = useConversationContext();

  const steps = toolCalls.reduce<ProgressStep[]>((all, call) => all.concat(call.metadata.steps || []), []);
  const queue = recommendationQueue(toolCalls);
  const pinned = latestRecommendations(messages);
  const showing = pinned && queue?.id === pinned.id && !cleared(pinned);

  return <StepCard collapsed={!showing} steps={steps} />;
}
